module.exports = __webpack_public_path__ + "static/media/logo.50a1d664.png";